import Api from "@root/components/api";

export default class StructureMutation {
    preprocess(structure) {
        structure.items.forEach(item => {
            const data = JSON.parse(item.labels);
            item.areas = data.areas;
            item.targets = data.targets;
        });
    }

    async create(name, description) {
        let query = `mutation ($name: String!, $description: String!) {
            createStructure(name: $name, description: $description) {
                id
            }
        }`;    
        const response = await Api.postData('/g', { 
            query: query, 
            variables: {
                name: name,
                description: description,
            }
        });
        return response.data.createStructure.id;
    }

    async publish(structureId) {
        let query = `mutation ($structureId: String!) {
            publishStructure(structureId: $structureId)
        }`;    
        const response = await Api.postData('/g', { 
            query: query, 
            variables: {
                structureId: structureId,
            }
        });
        return response.data.publishStructure;
    }

    async unpublish(structureId) {
        let query = `mutation ($structureId: String!) {
            unpublishStructure(structureId: $structureId)
        }`;    
        const response = await Api.postData('/g', { 
            query: query, 
            variables: {
                structureId: structureId,
            }
        });
        return response.data.unpublishStructure;
    }

    async save(structure) {
        let query = `mutation ($input: StructureInput!) {
            saveStructure(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: structure.id,
                name: structure.name, 
                description: structure.description,                
                theme: structure.theme,
                backgroundUrl: structure.backgroundUrl,
                width: structure.width,
                height: structure.height,
                backgroundOffsetX: structure.backgroundOffsetX,
                backgroundOffsetY: structure.backgroundOffsetY,
                items: structure.items.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        description: item.description,
                        x: item.x,
                        y: item.y,
                        skills: item.skills.map(c=>c.id),
                        structures: item.structures.map(c=>c.id),
                        labels: JSON.stringify({
                            areas: item.areas.map(area => {
                                return {
                                    id: area.id,
                                    closed: area.closed,
                                    points: area.points.map(point => {
                                        return {
                                            id: point.id,
                                            x: point.x,
                                            y: point.y,
                                        };
                                    }),
                                };
                            }),
                            targets: item.targets.map(target => {
                                return {
                                    id: target.id,
                                    x: target.x,
                                    y: target.y,
                                };
                            }),
                        }),                        
                    };
                }),
            }
        }});
    }    
}